import styled from 'styled-components';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _noop from 'lodash/noop';

import ShareButton from '../ShareButton';

const Share = styled(ShareButton).attrs((props) => ({
    ...props,
    shape: 'hollow-borderless',
    size: 'md',
    hasHover: false,
}))`
    font-weight: bold;
    line-height: normal;
    padding: 0px;
    line-height: 1;
`;

Share.propTypes = {
    mediaId: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

Share.defaultProps = {
    onClick: _noop,
};

export default Share;
